<template>
  <v-overlay v-model="show" :absolute="true"
    z-index="201" :opacity="0.8" :dark="$vuetify.theme.dark">
    <v-card>
      <v-card-text v-if="channel">
        <div v-if="hasNotJoined" v-html="$t('chat.messageOverlay.notJoined', { roomName: channel.formatName() })" />
        <div v-if="archived" v-html="$t('chat.messageOverlay.archived', { roomName: channel.formatName() })" />
      </v-card-text>
      <v-card-actions v-if="hasNotJoined">
        <v-spacer/>
          <v-btn text v-if="$vuetify.breakpoint.mobile"
            @click="$emit('open-menu')">
            {{ $t('chat.openMenu') }}
          </v-btn>
          <v-spacer />
          <v-btn text color="primary"
            @click="submitJoin()">
            {{ $t('chat.contextMenu.join') }}
          </v-btn>
      </v-card-actions>
      <v-card-actions v-if="archived">
        <v-spacer/>
          <v-btn text v-if="$vuetify.breakpoint.mobile"
            @click="$emit('open-menu')">
            {{ $t('chat.openMenu') }}
          </v-btn>
          <v-spacer />
          <v-btn text color="primary"
            v-if="channel.isOwner()"
            @click="submitRestore()">
            {{ $t('chat.contextMenu.restore') }}
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'chat-channels-message-overlay',
  computed: {
    ...mapGetters({
      currentUser: 'chat/authenticatedRocketChatUser',
      channels: 'chat/channels'
    }),

    channel () {
      if (this.$route?.params.roomType === 'channel') {
        return this.channels.find(channel => channel.id === this.$route?.params?.roomId)
      }
      return null
    },

    selected () {
      return this.$route?.params.roomType === 'channel' &&
        this.$route?.params?.roomId === this.channel?.id
    },

    hasNotJoined () {
      return !this.channel?.isCurrentUserParticipating(this.currentUser) && !this.channel?.isOwner() && !this.channel?.archived
    },

    archived () {
      return this.channel?.archived
    },

    show () {
      return this.selected && (this.hasNotJoined || this.archived)
    }
  },
  methods: {
    ...mapActions({
      join: 'chat/joinChannel',
      restore: 'chat/restoreChannel',
      setContextMenuChannel: 'chat/setContextMenuChannel'
    }),

    submitJoin () {
      this.setContextMenuChannel(this.channel)
      this.join()
    },

    submitRestore () {
      this.setContextMenuChannel(this.channel)
      this.restore()
    }
  }
}
</script>

<style>
</style>
